import getInitial from 'owa-persona/lib/utils/getInitial';
import getTextBoyColor from 'owa-persona/lib/utils/getTextBoyColor';
import PersonaBlob from 'owa-persona/lib/store/schema/PersonaBlob';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';

/**
 * Create a dummy Persona for string locations to show String locations as resolved entity
 * @param locationName: location displayName
 */
export function createLocationPersonaFromStringLocation(
    locationName: string
): LocationPersonaControlViewState {
    let postalAddress = createDefaultPostalAddress();

    return {
        personaId: locationName,
        displayName: locationName,
        postalAddress: postalAddress,
        displayAddress: '',
        initials: getInitial(locationName),
        textBoyColor: getTextBoyColor(locationName),
        personaBlob: createStringLocationPersonaBlob(),
        selectionSource: 'String',
        personaType: 'Unknown',
        personaControlId: locationName,
    };
}

/**
 * Creates a persona blob for a location with no map. This will represent the state of the persona blob after a fech photo would complete
 */
function createStringLocationPersonaBlob(): PersonaBlob {
    //  Personas with no photos would have hasFetchFailed= true after the feth complete.
    return {
        blobUrl: null,
        isPendingFetch: false,
        hasFetchFailed: true,
    };
}

/**
 * Creates a default postal address of Type "Home" and location soure "None"
 */
function createDefaultPostalAddress(): PersonaPostalAddress {
    return {
        Type: 'Business',
        LocationSource: 'None',
    };
}
